import { Component, Input } from '@angular/core';

import { ApiCollectionExportModalComponent } from '../../../modals/api-collection-export-modal/api-collection-export-modal.component';
import { Customer } from '../../../../../../models/customer';
import { ListResponse } from '../../../../../../models/list-response';
import { loadApiExport } from '../../../../../../models/exports/utils';
import { CallbackResultStatus, generateCsvDownload } from '../../../../../../utils';

/**
 * A shared download modal component for all API collections.
 */
@Component({
  selector: 'app-customer-export-modal',
  templateUrl: './customer-export-modal.component.html',
  styleUrls: ['./customer-export-modal.component.css']
})
export class CustomerExportModalComponent extends ApiCollectionExportModalComponent<Customer> {
  @Input() getPageParentsAndGuardiansOnly: (pageNum: number) => Promise<ListResponse<Customer>>;
  @Input() customFieldColumnNames: string[] = [];
  // Optional column names to pre-check in the export selector. Used by the
  // Customers list to default the export selection to the columns the user
  // currently has visible in the table.
  @Input() preSelectedColumnNames: string[] = [];

  public exportParentsAndGuardians = false;
  public loadingParentsAndGuardians = false;
  public generalColumnNames: string[] = [];

  ngOnInit() {
    this.generalColumnNames = [...this.columnNames];
    // Append custom-field column names (excluding any already in columnNames).
    for (const customFieldName of this.customFieldColumnNames) {
      if (!this.columnNames.includes(customFieldName)) {
        this.columnNames = [...this.columnNames, customFieldName];
      }
    }
    super.ngOnInit();

    for (const preSelected of this.preSelectedColumnNames) {
      if (preSelected in this.selectedColumns) {
        this.selectedColumns[preSelected] = true;
      }
    }
  }

  /**
   * A custom version of getPageInternal which adds parents and guardians after
   * the main export if exportParentsAndGuardians is true.
   */
  public handleSubmit() {
    if (!this.downloadFileName) {
      this.downloadFileName = this.defaultDownloadFileName;
    }

    this.pageNum = 0;

    this.loadingDownload = true;

    loadApiExport<Customer>(
      this.getSelectedColumnsList(),
      (pageNum) => {
        this.pageNum = pageNum;
        return this.getPageInternal(pageNum);
      },
      this.getContentItem,
      () => this.modalClosed
    )
      .then(baseContent => {
        // Do not generate the CSV if the modal has been closed.
        if (this.modalClosed) {
          return;
        }

        if (this.exportParentsAndGuardians) {
          this.loadingParentsAndGuardians = true;

          return loadApiExport<Customer>(
            this.getSelectedColumnsList(),
            (pageNum) => {
              this.pageNum = pageNum;
              return this.getPageParentsAndGuardiansOnly(pageNum);
            },
            this.getContentItem,
            () => this.modalClosed
          ).then(parentsAndGuardiansContent => {
            // Do not generate the CSV if the modal has been closed.
            if (this.modalClosed) {
              return;
            }

            generateCsvDownload(
              baseContent.concat(parentsAndGuardiansContent.slice(1)),
              this.downloadFileName
            );

            this.savedCallback({
                text: this.exportNameHumanReadable + ' export downloaded successfully.',
                status: CallbackResultStatus.success
              });
            this.activeModal.close();
          });
        } else {
          generateCsvDownload(
            baseContent,
            this.downloadFileName
          );

          this.savedCallback({
              text: this.exportNameHumanReadable + ' export downloaded successfully.',
              status: CallbackResultStatus.success
            });
          this.activeModal.close();
        }
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => {
        this.loadingDownload = false;
        this.loadingParentsAndGuardians = false;
      });
  }
}
